


















import { Component, Vue } from 'vue-property-decorator';
import IntegrationTab from './integrations.tab.vue';

@Component({
  components: {
    IntegrationTab,
  },
})
export default class IntegrationsShell extends Vue {
  tabs = [
    {
      name: 'providers-and-buyers',
      prettyName: 'Providers & Buyers',
      icon: 'mdi-share-variant',
      integrators: [
        {
          code: 'SEJOUR',
          prettyName: 'Sejour',
          image: require('../../../assets/integrators/sejour.png'),
          fields: [
            { type: 'text', name: 'path' },
            { type: 'text', name: 'operator' },
          ],
        },
      ],
    },
    {
      name: 'channel-managers',
      icon: 'mdi-lan',
      prettyName: 'Otas',
    },
    {
      name: 'otas',
      icon: 'mdi-wan',
      prettyName: 'Channel Managers',
    },
  ];

  currentTab = this.tabs[0].name;
}
